// Pure sanitizers for the games-side persistence (no Firebase import, so they
// are unit-testable). Firebase RTDB set() THROWS if any value anywhere in the
// payload is `undefined` — these strip that risk before every write.

// Deep-remove undefined (keeps null, 0, false, '' and arrays). Objects with an
// undefined field would otherwise make RTDB reject the whole write.
export function stripUndefinedDeep(v) {
  if (Array.isArray(v)) return v.map(stripUndefinedDeep)
  if (v && typeof v === 'object') {
    const out = {}
    for (const [k, val] of Object.entries(v)) {
      if (val === undefined) continue
      out[k] = stripUndefinedDeep(val)
    }
    return out
  }
  return v
}

// Drop setup-only option keys (prefixed `__`, e.g. the Scats config) so they
// never reach the stored game options — and can't smuggle in undefined values.
export function stripSetupKeys(options) {
  const out = {}
  for (const [k, v] of Object.entries(options || {})) if (!k.startsWith('__')) out[k] = v
  return out
}

// True if any value nested anywhere is undefined (used by tests to prove a
// payload is RTDB-safe).
export function hasUndefinedDeep(v) {
  if (v === undefined) return true
  if (Array.isArray(v)) return v.some(hasUndefinedDeep)
  if (v && typeof v === 'object') return Object.values(v).some(hasUndefinedDeep)
  return false
}
